import { Component, OnInit } from '@angular/core';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;

  settingsgroupColl: any = [];
  settingsColl: any = [];

  istds: boolean = false;
  ispf: boolean = false;
  isesi: boolean = false;



  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  settingsgroupname = "";

  formname: string = "Settings";

  constructor(private appService: AppdataService, private loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService) {
    this.fnServiceChanges();
  }



  //Company Check
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  //Init
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fngetSettings();
  }


  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }

  fnSettingsGroupClick(pBO) {
    this.settingsgroupname = pBO.settingstype;

    for (let abo of this.settingsgroupColl) {
      if (abo.settingstype === pBO.settingstype) {
        abo.activeCls="activetab"
      }
      else {
        abo.activeCls=""
      }
    }

    
  }

  //Get
  fngetSettings() {
    var data = {
      'settingsid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getSettings(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.settingsgroupColl = res.json().result[0];
            this.settingsColl = res.json().result[1];
           

            for (let abo of this.settingsColl) {
              if (abo.fieldtype === 'LOOKUP') {
                abo.settingsvalueoptionslookup = abo.settingsvalueoptions.replace(/ /g, '').split(',')
              }
              if (abo.fieldtype === 'CHECKBOX') {

                if (abo.settingsvalue === '1') {
                  abo.checksettingsvalue = true;
                }
                else {
                  abo.checksettingsvalue = false;
                }
              }
            }
            for (let row of this.settingsColl) {


              if (row.settingsname === 'ENABLE ESI' && row.settingsvalue === '1') {

                this.isesi = true;

              }

            }

            if (this.settingsgroupColl.length > 0) {
              this.settingsgroupColl[0].activeCls = "activetab"
              this.settingsgroupname = this.settingsgroupColl[0].settingstype;
            }
           


          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnSaveBtnClick() {

    for (let row of this.settingsColl) {
      if (row.fieldtype === 'CHECKBOX' && row.checksettingsvalue === true) {
        row.settingsvalue = 1;
      }
      else if (row.fieldtype === 'CHECKBOX' && row.checksettingsvalue !== true) {
        row.settingsvalue = 0;
      }

      row.companyid=this.loginService.fnGetCompanyId()
      this.fnSetSettings(row);
      this.fnCloseForm();
    }
  }

  fnSetSettings(data) {

    this.appService.fnSetSettings(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }
  fnCloseForm() {
    try {
      this.router.navigate(['/']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }


}
